import { Box } from '../Common/Box';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext, useMemo } from 'react';
import { PaymentMethodEnum, type ExcludeOtherPaymentMethod } from '@/types/common';
import { DrawerScreen } from '@/types/screens';
import { getOtherPaymentMethods } from '@/utils/paymentMethods';
import { isMobileDevice } from '@/utils/device';
import OtherPaymentMethodLogo from '@/assets/icons/common/other.svg';

export const OtherPaymentMethod = () => {
  const {
    paymentMethodSelected,
    paymentMethodsAvailable,
    actions: { setPaymentMethodSelected, updateOtherMethodSelected },
    drawer: { setDrawerScreen },
  } = useContext(CheckoutContext);

  const otherPaymentMethods = useMemo(() => getOtherPaymentMethods(paymentMethodsAvailable), [paymentMethodsAvailable]);
  const isSelected = useMemo(
    () =>
      paymentMethodSelected === PaymentMethodEnum.OTHER ||
      otherPaymentMethods.some((pm) => pm.paymentMethodName === paymentMethodSelected),
    [paymentMethodSelected, otherPaymentMethods]
  );

  const handleSelect = () => {
    updateOtherMethodSelected(paymentMethodSelected as ExcludeOtherPaymentMethod);
    if (isMobileDevice()) {
      setDrawerScreen(DrawerScreen.OTHER_PAYMENT_METHOD);
    } else {
      setPaymentMethodSelected(PaymentMethodEnum.OTHER);
    }
  };

  return (
    <Box isSelected={isSelected} onSelect={handleSelect}>
      <div className="flex flex-row items-center gap-1">
        <img src={OtherPaymentMethodLogo} alt="other" />
        <div className="text-sm color-base-foreground">Other</div>
      </div>
    </Box>
  );
};
